import { Button, Card, CardBody, Flex, Heading, IconButton, Spinner } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

import { LeftArrowIcon, SaveWhiteIcon } from '@assets/icons/index.js';
import { ConfirmationState2 } from '@assets/images';
import { ConditionalComponent } from '@components/functionComponent';
import { usePopUpNotification } from '@store/popupNotification';
import { useSnackbarNotification } from '@store/snackbarNotification';
import { useConfirmModal } from '@store/useConfirmModal';
import { useUserInfo } from '@store/userInfo';

import { usePopUpAssetStore, usePopUpStore } from '@pages/UploadSellout/components/uploadPopUp/state';
import { convertData, dateValidation } from '@pages/UploadSellout/helpers/converter';
import { onUploadFile } from '@pages/UploadSellout/helpers/crud';
import { useDataKonversi } from '@pages/UploadSellout/hooks/state/useDataKonversi';

const Header = () => {
    const navigate = useNavigate();
    const popUpStore = usePopUpStore();
    const { onChangePopUpNotification } = usePopUpNotification();
    const { onChangeSnackbarNotification } = useSnackbarNotification();

    const { onChangePopUpStore, onResetPopUpStore, isUploading: isLoading } = popUpStore;

    const { onChangePopupAssetStore } = usePopUpAssetStore();
    const { userInfo } = useUserInfo();

    const { set: setConfirmModal } = useConfirmModal();
    const konversi = useDataKonversi();
    const { sellout_summary, resetData } = konversi;

    const handleCancel = () => {
        setConfirmModal({
            isOpen: true,
            ConfirmationStateImage: ConfirmationState2,
            title: 'Batalkan Proses Konversi?',
            desc: 'Data yang telah ditambahkan akan hilang, perlu melakukan upload ulang untuk menyelesaikan proses konversi',
            btnLabelYes: 'Batalkan Konversi',
            btnLabelNo: 'Kembali',
            onSubmit: () => {
                resetData();
                navigate(-1);
            },
        });
    };

    const handleClose = () => {
        onChangePopUpStore({
            isOpen: false,
        });
    };

    const handleSave = async () => {
        if (
            sellout_summary?.total_failed > 0 ||
            sellout_summary?.total_success === 0 ||
            !dateValidation(konversi.data.success_data)
        ) {
            return setConfirmModal({
                isOpen: true,
                isDanger: false,
                title: 'Data Upload Belum Sesuai',
                desc: 'Perbaiki dan periksa kembali seluruh informasi sebelum disimpan.',
                btnLabelYes: 'Mengerti',
                isShowBtnNo: false,
            });
        }
        const rawFilename = sellout_summary?.smart_upload_filename;
        const filename = rawFilename
            ? `${rawFilename.replace(/\.[^/.]+$/, '')}.xlsx`
            : `data-konversi-${Date.now()}.xlsx`;

        try {
            const buffer = await convertData(konversi);
            const selectedFile = new File(
                [
                    new Blob([buffer], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    }),
                ],
                filename,
                {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                },
            );

            const popUpData = {
                selectedFormatUploadType: 'Format Paragon',
                selectedTimeUploadType: sellout_summary.sellout_type?.toLowerCase(),
                selectedTimeUploadValue: [new Date(sellout_summary.start_date), new Date(sellout_summary.end_date)],
            };
            await onUploadFile({
                isConversion: true,
                rawFilename,
                popUpStore: { ...popUpData, selectedFile },
                onChangePopUpStore,
                onResetPopUpStore,
                onClose: handleClose,
                isCanUpload: true,
                onChangePopUpNotification,
                userInfo,
                onChangePopupAssetStore,
                onChangeSnackbarNotification,
                onNavigate: (path) => navigate(path, { replace: true }),
                onResetFile: () => {},
                onRefetchUploadData: () => {},
                onSmartUploadSuccess: () => {},
            });
        } catch (error) {
            console.error(error);
            const errorMessage =
                error?.message || error?.response?.data?.message || 'Terjadi kesalahan saat mengonversi data.';
            setConfirmModal({
                isOpen: true,
                isDanger: false,
                ConfirmationStateImage: ConfirmationState2,
                title: 'Gagal Memproses Data',
                desc: errorMessage,
                btnLabelYes: 'Tutup',
                isShowBtnNo: false,
            });
        }
    };

    return (
        <Card backgroundColor="semantic.100" borderRadius="lg">
            <CardBody as={Flex} flexDirection="row" justifyContent="space-between" alignItems="center" padding="16px">
                <Flex flexDirection="row" justifyContent="flex-start" alignItems="center" gap="12px">
                    <IconButton
                        aria-label="back button"
                        variant="outline"
                        size="sm"
                        borderColor="transparent"
                        paddingX={0}
                        icon={<LeftArrowIcon />}
                        onClick={handleCancel}
                    />
                    <Heading fontSize="24px" fontWeight="600">
                        Proses Konversi
                    </Heading>
                </Flex>
                <Flex flexDirection="row" gap="12px">
                    <Button variant="outline" borderRadius="md" onClick={handleCancel}>
                        Batal
                    </Button>
                    <Button variant="solid" borderRadius="md" isDisabled={isLoading} onClick={handleSave}>
                        <ConditionalComponent statement={isLoading} fallback={<SaveWhiteIcon />}>
                            <Spinner />
                        </ConditionalComponent>
                        Simpan
                    </Button>
                </Flex>
            </CardBody>
        </Card>
    );
};

export default Header;
